module.exports = __webpack_public_path__ + "static/media/guestonline-2.17a54a87.png";